/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntakeFormDocumentPresignedRequestDto = {
    /**
     * MIME type of the file
     */
    fileType: IntakeFormDocumentPresignedRequestDto.fileType;
    /**
     * Original filename (allowed: jpg, jpeg, png, pdf)
     */
    fileName: string;
    /**
     * File size in bytes (max 10 MB). Used for pre-upload validation.
     */
    fileSize?: number;
};
export namespace IntakeFormDocumentPresignedRequestDto {
    /**
     * MIME type of the file
     */
    export enum fileType {
        IMAGE_JPEG = 'image/jpeg',
        IMAGE_PNG = 'image/png',
        IMAGE_HEIC = 'image/heic',
        APPLICATION_PDF = 'application/pdf',
    }
}

